module.exports = __webpack_public_path__ + "static/img/usina.102b046.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/usina.jpg
// module id = E7Bc
// module chunks = 1